import React, { useState } from 'react';
import { Grid2, Modal } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setPatientInformation } from '../../store/slices/metaDataSlice';
import { SingleNumberCard } from '../../shared/components/numberInput/numberCards/singleNumberCard';
import { InfoPopup } from './InfoPopup';

export const MetricView = () => {
  const { patientInformation } = useAppSelector(metaDataSelector);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Grid2 display={'flex'} flexDirection="row" paddingTop={'1.25rem'}>
        <SingleNumberCard
          width={'50%'}
          title={'HEIGHT'}
          marginVal={'0.625rem'}
          range={{ min: 0, max: 250 }}
          subHead={'(cm)'}
          value={patientInformation?.metric?.height}
          setValue={(val: number) =>
            dispatch(
              setPatientInformation({
                ...patientInformation,
                metric: {
                  ...patientInformation.metric,
                  height: Number(val.toFixed(1))
                },
                imperial: {
                  ...patientInformation.imperial,
                  height: { ft: 0, in: 0 }
                }
              })
            )
          }
        />
        <SingleNumberCard
          width={'50%'}
          title={'WEIGHT'}
          subHead={'(kg)'}
          range={{ min: 0, max: 1000 }}
          value={patientInformation?.metric?.weight}
          setValue={(val: number) =>
            dispatch(
              setPatientInformation({
                ...patientInformation,
                metric: { ...patientInformation.metric, weight: Number(val) },
                imperial: {
                  ...patientInformation.imperial,
                  weight: { st: 0, lb: 0 }
                }
              })
            )
          }
        />
      </Grid2>

      <Grid2 display={'flex'} flexDirection="row" paddingTop={'1.25rem'}>
        <SingleNumberCard
          width={'50%'}
          title={'USUAL WEIGHT'}
          marginVal={'0.625rem'}
          range={{ min: 0, max: 1000 }}
          subHead={'(kg - in the past 3-6 months)'}
          value={patientInformation?.metric?.usualWeight}
          setValue={(val: number) =>
            dispatch(
              setPatientInformation({
                ...patientInformation,
                metric: {
                  ...patientInformation.metric,
                  usualWeight: Number(val)
                },
                imperial: {
                  ...patientInformation.imperial,
                  usualWeight: { st: 0, lb: 0 }
                }
              })
            )
          }
        />
        <SingleNumberCard
          width={'50%'}
          title={'ESTIMATED DRY WEIGHT'}
          subHead={'(kg)'}
          infoIconVal={true}
          range={{ min: 0, max: 1000 }}
          infoIconClick={handleOpen}
          value={patientInformation?.metric?.estimatedDryWeight}
          setValue={(val: number) =>
            dispatch(
              setPatientInformation({
                ...patientInformation,
                metric: {
                  ...patientInformation.metric,
                  estimatedDryWeight: Number(val)
                },
                imperial: {
                  ...patientInformation.imperial,
                  estimatedDryWeight: { st: 0, lb: 0 }
                }
              })
            )
          }
        />
      </Grid2>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <InfoPopup onClose={handleClose} />
      </Modal>
    </>
  );
};
